import http from '../utils/request'

/**
 * 报表中心 — 对应后端 ReportController (/api/Report)
 */

// ============ 报表类型模版 ============
export const getReportTypes = () => http.get('/Report/types')

// ============ 系统报表模版（Para4=1 的系统报表作为可复用模版） ============
export const getSystemTemplates = () => http.get('/Report/system-templates')

// ============ 报表目录 ============
export const getCatalogs = () => http.get('/Report/catalogs')
export const saveCatalog = (catalog) => http.post('/Report/catalogs', catalog)
export const deleteCatalog = (guid) => http.delete(`/Report/catalogs/${guid}`)

// ============ 报表 CRUD ============
export const getReports = (catalogGuid) => http.get('/Report', { params: { catalogGuid: catalogGuid || '' } })
export const getAllReports = (type) => http.get('/Report/all', { params: { type: type || undefined } })
export const getEfficientReports = () => http.get('/Report/efficient')
export const getReport = (guid) => http.get(`/Report/${guid}`)
export const getReportParams = (guid) => http.get(`/Report/${guid}/params`)
export const saveReportParams = (guid, params) => http.post(`/Report/${guid}/params`, params)
export const getReportColumns = (guid) => http.get(`/Report/${guid}/columns`)
export const saveReportColumns = (guid, columns) => http.post(`/Report/${guid}/columns`, columns)
export const deleteReportColumn = (guid, columnGuid) => http.delete(`/Report/${guid}/columns/${columnGuid}`)
export const updateReportColumns = (guid) => http.post(`/Report/${guid}/columns/update`)
export const resetReportColumns = (guid) => http.post(`/Report/${guid}/columns/reset`)
export const getDbObjects = () => http.get('/Report/db-objects')
export const getDbColumns = (name) => http.get('/Report/db-columns', { params: { name } })
export const saveReport = (report) => http.post('/Report', report)
export const deleteReport = (guid) => http.delete(`/Report/${guid}`)
export const toggleReportStatus = (guid) => http.put(`/Report/${guid}/toggle-status`)

// ============ 报表模板库 ============
export const getTemplates = (templateType, category) => http.get('/Report/templates', { params: { templateType: templateType ?? undefined, category: category || undefined } })
export const getTemplate = (guid) => http.get(`/Report/templates/${guid}`)
export const saveTemplate = (template) => http.post('/Report/templates', template)
export const deleteTemplate = (guid) => http.delete(`/Report/templates/${guid}`)

// ============ SQL 执行 ============
export const executeReportSql = (sql, isProcedure) => http.post('/Report/execute', { sql, isProcedure: !!isProcedure })
